import util from '@utils/util';
export default {
  name: 'CardHead',
  props: {
    videoid: String,
    userInfo: {
      type: Object,
      default: null
    }
  },
  methods: {
    turnHttps: function turnHttps(url) {
      if (url) {
        return util.forceHttps(url);
      } else {
        return '';
      }
    },
    defaultUserPortrait: function defaultUserPortrait(userInfo) {
      return util.defaultUserPortrait(userInfo);
    },
    getSexClass: function getSexClass(sex) {
      sex = +sex;
      if (!(sex === 0 || sex === 1)) {
        sex = 0;
      }
      return sex === 0 ? 'female' : 'male';
    },
    getLevelImage: function getLevelImage() {
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return "url(/app/static/images/blank_level/".concat(Math.floor(level / 10), "0-").concat(Math.floor(level / 10), "9.png)");
    },
    getAnchorLevelImage: function getAnchorLevelImage() {
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      try {
        return "url(/app/static/images/anchorLevel/".concat(level < 10 ? '' : Math.floor(level / 10), "0-").concat(level < 10 ? '' : Math.floor(level / 10), "9level.png)").replace('00-09', '0-9');
      } catch (e) {
        console.log(e);
      }
    }
  }
};